/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-28 16:55:41
 * @modify date 2023-11-28 16:55:41
 * @desc [description]
 */

import ContentBox from "components/base/tamplate/ContentBox";
import { ContentContainerProps } from "interfaceTypes/ContentsProps";
import { useTranslation } from "react-i18next";
import { StyleSheet, View, Text, Pressable } from "react-native";
import { FONT } from "value/staticValues";
import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';
import { ReactComponent as InActiveCheckBoxImg } from '../../../img/btn-checkbox-incon-circle-inactive.svg';
import { ReactComponent as ActiveCheckBoxImg } from '../../../img/btn-checkbox-incon-circle-active.svg';
import CustomText from "components/base/CustomText";
import { CustomTextInput, TextArea } from "components/base/CustomInputText";
import { useState } from "react";
import { SmtpMgmtData } from "./SmtpMgmtData";



interface SmtpMgmtProps extends ContentContainerProps{
  clickUpdateBtnCb: ()=>void;
  clickSendMailBtnCb: ()=>void;
  receiveMail: string;
  setReceiveMail: (v)=>void;
  receiveContents: string;
  setReceiveContents: (v)=>void;
  queryData: SmtpMgmtData;
}



function SmtpBasicInfoTitleValueView({title, value, activePort=false}:{title:string, value:string, activePort?:boolean}) {
  const { t } = useTranslation();

  return (
    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
      <Text style={style.boxContentHeaderText}>
          {title}
      </Text>
      <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
          {value}
      </Text>
      {
        (title === t("MENU_APPLICATION_SMTP_SERVER_PORT")) &&
        <View style={{marginLeft: 10, flexDirection: 'row', alignItems: 'center'}}>
            {(activePort) ? <ActiveCheckBoxImg/> : <InActiveCheckBoxImg/>}
            <Text style={{...style.boxContentHeaderText, marginLeft: 8}}>
              {t("MENU_APPLICATION_SMTP_SEND_TLS")}
            </Text>
        </View>
      }
    </View>
  )
}



export default function SmtpMgmtView(props:SmtpMgmtProps) {
  const { t } = useTranslation();

  const [k, sk] = useState("");

  return (
    <ContentBox title={t("MENU_APPLICATION_SMTP")} subtitle={t("MENU_APPLICATION_SMTP_GUIDE")} infoText={props.infoText} infoError={props.infoError}>
       <View style={style.topContainer}>
          <View style={{flexDirection: "row"}}>
            <View style={{width: 840, marginRight: 10}}>

              <View style={{...style.boxContainer}}>
                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                    <Text style={style.boxContentTitle}>
                        {t("BASE_INFO_TEXT")}
                    </Text>

                    <div
                      style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer"}}
                      onClick={(e) => {props.clickUpdateBtnCb()}}
                    >
                        <TableEditImg/>
                        <Text style={{
                            marginLeft: 2,
                            fontFamily: FONT.MEDIUM,
                            fontSize: 12,
                            color: "#3c5df2"
                        }}>
                            {t("INFO_EDIT_TEXT")}
                        </Text>
                    </div>
                </View>


                {/* 기본 정보 */}
                <View>
                  <SmtpBasicInfoTitleValueView title={t('MENU_APPLICATION_SMTP_SEND_EMAIL')} value={props.queryData?.smtp_sender_address}/>
                  <SmtpBasicInfoTitleValueView title={t('MENU_APPLICATION_SMTP_SEND_NAME')} value={props.queryData?.smtp_sender_name}/>
                  <SmtpBasicInfoTitleValueView title={t('MENU_APPLICATION_SMTP_TITLE_PREFIX')} value={props.queryData?.smtp_prefix}/>
                  <SmtpBasicInfoTitleValueView title={t('MENU_APPLICATION_SMTP_SERVER_HOST')} value={props.queryData?.smtp_host}/>
                  <SmtpBasicInfoTitleValueView title={t('MENU_APPLICATION_SMTP_SERVER_PORT')} value={props.queryData?.smtp_port} activePort={props.queryData?.smtp_tls_yn ? true : false}/>
                  <SmtpBasicInfoTitleValueView title={t('MENU_APPLICATION_SMTP_ACCOUNT_NAME')} value={props.queryData?.smtp_username}/>
                  <SmtpBasicInfoTitleValueView title={t('MENU_APPLICATION_SMTP_RECEIVE_EMAIL')} value={props.queryData?.support_manager}/>
                </View>


                <div style={{borderWidth: 1, border: "solid 0.5px #eee", marginBottom: 30}}/>


                {/* InputText */}
                <View style={{flexDirection: "row", alignItems: "center"}}>
                  <CustomText text={t("MENU_APPLICATION_SMTP_INPUT_RECEIVE_EMAIL")} fontStyle={style.boxContentHeaderText} asterisk={false}/>
                  <CustomTextInput
                    width={320} height={36}
                    value={props.receiveMail}
                    type={"text"}
                    activeYn={true}
                    inputCb={props.setReceiveMail}
                    warnYn={false}
                    placeHolderText={t("MENU_APPLICATION_SMTP_RECEIVE_EMAIL_HINT")} />
                </View>


                <View style={{flexDirection: "row", alignItems: "center", marginTop: 20}}>
                  <CustomText text={t("MENU_APPLICATION_SMTP_INPUT_RECEIVE_EMAIL_CONTENTS")} fontStyle={style.boxContentHeaderText} asterisk={false}/>
                  <TextArea
                    width={320} height={120}
                    value={props.receiveContents}
                    type={"text"}
                    activeYn={true}
                    inputCb={props.setReceiveContents}
                    warnYn={false}
                    placeHolderText={t("MENU_APPLICATION_SMTP_RECEIVE_EMAIL_CONTENTS_HINT")} />

                  <Pressable style={{
                    width: 120,
                    height: 36,
                    backgroundColor: 'white',
                    marginLeft: 50,
                    borderRadius: 10,
                    borderColor: '#d4d9db',
                    borderWidth: 1,
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  onPress={()=>props.clickSendMailBtnCb()}>
                    <Text style={{fontFamily: FONT.MEDIUM, fontSize: 12, lineHeight: 10, color: "#262626"}}>
                      {t("MENU_APPLICATION_SMTP_SEND_TEST_EMAIL")}
                    </Text>
                  </Pressable>
                </View>
              </View>
            </View>
          </View>
        </View>
    </ContentBox>
  )
}



const style = StyleSheet.create({
  topContainer: {
      width: 1090,
      minHeight: 860,
  },
  boxContainer: {
      marginTop: 20,
      paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
      borderRadius: 8,
      boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
      borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
      backgroundColor: "#fff"
  },
  dateUpdate: {
      marginTop: 25,
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#333"
  },
  dateCreate: {
      marginTop: 6,
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#9ea0a5"
  },
  boxContentTitle: {
      fontFamily: FONT.MEDIUM,
      fontSize: 14,
      color: "#333"
  },
  boxContentTitleDescription: {
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#8c8c8c",
      marginLeft: 10
  },
  boxContentHeaderText: {
      width: 170,
      marginRight: 52,
      fontFamily: FONT.REGULAR,
      fontSize: 13,
      lineHeight: 12,
      color: "#333"
  },
  boxContentDataText: {
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#333"
  },
  boxContentEmptyDataText: {
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#acb0bf"
  },
  boxContentDataDescription: {
      marginTop: 15,
      fontFamily: FONT.REGULAR,
      fontSize: 11,
      color: "#9ea0a5"
  },
  boxAccounRole: {
      width: 100,
      height: 100,
      marginTop: -18,
      backgroundColor: "#4f5fd8",
      borderRadius: 60,
      alignItems:"center",
      justifyContent: "center"
  },
  boxAccountRoleText: {
      fontFamily: FONT.MEDIUM,
      fontSize: 12,
      color: "#fff"
  },
  boxAccounrRoleImg: {
      width: 50,
      height: 50,
  },
  settingImg: {
      marginLeft: "auto",
      cursor: "pointer"
  },
  resourceBox: {
      flexDirection: "row",
      width: 760, minHeight: 70,
      borderRadius: 10,
      backgroundColor: "#f5f7fa",
      padding: 20,
  },
  imgBox: {
      alignItems: "center", justifyContent: "center",
      width: 36, height: 36,
      marginRight: 16,
      borderRadius: 10,
      backgroundColor: "rgba(182, 191, 206, 0.3)",
  },
  resourceFixedText: {
      width: 75,
      marginRight: 90,
      fontFamily: FONT.REGULAR,
      fontSize: 13,
      lineHeight: 12,
      color: "#333"
  },
  resourceDataText: {
      fontFamily: FONT.BOLD,
      fontSize: 14,
      lineHeight: 14,
      color: "#333"
  },
  resourceSubText: {
      marginLeft: 6,
      fontFamily: FONT.REGULAR,
      fontSize: 11,
      lineHeight: 10,
      color: "#9ea0a5"
  },
});